import { z } from 'zod/v4';

/**
 * CRM pipeline objects as the host app persists them inside the form widget
 * (`selectedPipeline` / `selectedPipelineStep` / `selectedPipelineSettings`).
 * Mirrors `CrmPipeline`/`CrmPipelineStep`/`CrmPipelineSetting` from
 * `@integrations/crm-pipelines` — the raw CRM API shapes the editor
 * stores verbatim after the user picks them.
 */
export const crmPipelineSettingSchema = z.object({
    name: z.string(),
    // Opaque passthrough — see `CrmPipelineSettingContract`. Persisted widgets
    // carry whatever CRM answered when the pipeline was picked, so a narrow union
    // here makes legacy variant detection reject otherwise valid saved widgets.
    value: z.unknown(),
});

export const crmPipelineStepSchema = z.object({
    color: z.string(),
    id: z.number(),
    name: z.string(),
    order: z.number(),
    pipelineId: z.number(),
    status: z.number(),
});

export const crmPipelineSchema = z.object({
    id: z.number(),
    status: z.number(),
    name: z.string(),
    order: z.number(),
    userId: z.number(),
    settings: z.array(crmPipelineSettingSchema),
    steps: z.array(crmPipelineStepSchema),
});

export type CrmPipelineSetting = z.infer<typeof crmPipelineSettingSchema>;
export type CrmPipelineStep = z.infer<typeof crmPipelineStepSchema>;
export type CrmPipeline = z.infer<typeof crmPipelineSchema>;
